/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Change Calculator | Toolverse`)
};

const es_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Cambio Porcentual | Toolverse`)
};

const de_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für prozentuale Veränderung | Toolverse`)
};

const nl_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverandering berekenen | Toolverse`)
};

const fr_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de variation en pourcentage | Toolverse`)
};

const it_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di variazione percentuale | Toolverse`)
};

const pt_br2_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Variação Percentual | Toolverse`)
};

const pt_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Variação Percentual | Toolverse`)
};

const ja_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化計算機 | Toolverse`)
};

const zh_pct_change_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比变化计算器 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_meta_title", locale)
	if (locale === "en") return en_pct_change_meta_title(inputs)
	if (locale === "es") return es_pct_change_meta_title(inputs)
	if (locale === "de") return de_pct_change_meta_title(inputs)
	if (locale === "nl") return nl_pct_change_meta_title(inputs)
	if (locale === "fr") return fr_pct_change_meta_title(inputs)
	if (locale === "it") return it_pct_change_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_meta_title(inputs)
	if (locale === "pt") return pt_pct_change_meta_title(inputs)
	if (locale === "ja") return ja_pct_change_meta_title(inputs)
	return zh_pct_change_meta_title(inputs)
};